<div class="top-section">
  <h3>
    Booking List
  </h3>
</div>

<section class="rate-request  rate-request-sec">
  <div class="middle-section">
    <div class="container">
      <div class="rate-request-form">
        <!-- <div class="text-right mb-3 mt-3" *ngIf="!isadmin">
            <a class="btn btn-signIn" (click)="AddRateRequest()">Post Cargo</a>
          </div> -->
        <div class="rate-request-form-inner">
              <div class="col-md-3">
                  <select class="form-control" style="padding:0px 21px 2px" (change)="statusValue($event.target.value)" [(ngModel)]="selectrateStatus">
                    <option *ngFor="let name of options" 
                        [value]="name">{{name}} </option>  
                  </select>
          </div>
          <div class="request-btn">
            <!-- <i class="fa fa-search" style="margin:4px 4px 0 0"></i> -->
            <input type="text" class="form-control" pInputText size="50" placeholder="Search" (change)="filterSearch($event.target.value)">
            <div class="btn-search"><button class="btn  btn-go my-2 my-sm-0" type="submit"><img
                  src="../../../assets/images/Group 103.svg"></button></div>
          </div>
        </div>
        <div class="table-responsive rate-request-tbl">
          <p-table [value]="bookinglist">

            <ng-template pTemplate="header">
              <tr>
                <th>Booking Number</th>
                <th>From Port</th>
                <th>To Port</th>
                <!-- <th>Booking Id</th> -->
                <th>Booking Date</th>
                <th>Total Freight Cost</th>
                <th>Status</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-book>
              <tr>
                <td>{{book.bookingNumber}}</td>
                <td>{{book.fromPortName}}</td>
                <td>{{book.toPortName}}</td>
                <td>{{book.bookingDate | date: "dd-MM-yyyy"}}</td>
                <td> {{book.totalFreightCost}}</td>
                <td>
                  <span class="badge badge-awaiting-book-confirm"
                    *ngIf="book.status == bookingstatus.AwaitingBookingConfirmation">Awaiting Booking
                    Conformation</span>
                  <span class="badge badge-confirmed" *ngIf="book.status == bookingstatus.BookingConfirmed"> Booking
                    Conformed </span>
                <td class="text-right">
                  <!-- <button *ngIf="book.isOfferdbythisUser && book.status != bookingstatus.BookingConfirmed"
                    class="btn btn-signIn" (click)='ConfirmedBooking(book.bookingId)'> 
                     </button> -->                     
                  <a  class="action-btn " pTooltip="Conform Booking" tooltipPosition="top" *ngIf="book.isOfferdbythisUser && book.status != bookingstatus.BookingConfirmed"  (click)='ConfirmedBooking(book.bookingId)'>
                    <i class="fa fa-check-circle" style="font-size:22x;color:green"></i> 
                  </a>
                  <a class="action-btn assign-edit-btn" *ngIf="book.status != bookingstatus.BookingConfirmed"
                    tooltipPosition="top" pTooltip="Cancel" (click)="CancelBooking(book.bookingId)">                    
                    <i class="fa fa-trash-o" aria-hidden="true"></i>                   
                  </a>
                  <a class="action-btn text-success" tooltipPosition="top" pTooltip="View Booking" data-toggle="modal"
                    data-target=".view-modal"
                    (click)="GetBookingDetails(book.rateRequestId,book.fromPortName,book.toPortName,book.rateOfferedId)">
                    <i class="fa fa-eye"></i>
                  </a>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <p-paginator *ngIf="totalcount > 0" [rows]="pageSize" [rowsPerPageOptions]="[5,10,20]"
          [totalRecords]="totalcount" (onPageChange)="paginate($event)"></p-paginator>
        <div *ngIf="totalcount == 0">
          <span>No records found</span>
        </div>
      </div>
    </div>
  </div>
</section>

<p-confirmDialog  icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="modal fade view-modal modelzindex2 request-modal" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content text-left">
      <div class="modal-header">
        <h5 class="modal-title ">Booking Details</h5>
        <button type="button" data-dismiss="modal" aria-label="Close" class="close-btn">
          <span class="pi pi-fw pi-times"></span>
        </button>
      </div>
      <div class="modal-body">

        <div class="ports">
          <div class="portleft">
            <div class="form-group contact">
              <label class="custom-labal">
                Name:
              </label>
              <span>
                {{contactName}} 
              </span>
            </div>
            <div class="form-group contact">
              <label class="custom-labal">
                Email:
              </label>
              <span>
                {{contactEmail}}
              </span>
            </div>
            <div class="form-group">
              <label class="custom-labal">
                Number:
              </label>
              <span>
                {{phoneNumber}}
              </span>
            </div>
          </div>
        </div>

        <div class="ports">
          <div class="portleft">
            <div class="form-group">
              <label class="custom-labal ">
                From Port
              </label>
              <span>
                {{frmport}}
              </span>
            </div>
            <span class="arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="54.963" height="6.658" viewBox="0 0 54.963 6.658">
                <defs>
                  <style>
                    .a {
                      fill: #c2cadb;
                    }
                  </style>
                </defs>
                <path class="a"
                  d="M-40.135,35.387c2.834.005,47.913.131,50.747.077-.305.308-.607.62-.9.94-.771.846.483,2.108,1.258,1.258.856-.939,1.773-1.816,2.714-2.669a.8.8,0,0,0-.033-1.245.959.959,0,0,0-.236-.241c-.874-.629-1.712-1.3-2.534-2-.87-.737-2.135.516-1.258,1.258q.548.464,1.109.912c-2.874.06-47.993-.068-50.867-.073A.89.89,0,0,0-40.135,35.387Z"
                  transform="translate(40.996 -31.286)" />
              </svg>

            </span>
            <div class="form-group">
              <label class="custom-labal ">
                To Port
              </label>
              <span>
                {{toport}}
              </span>
            </div>
          </div>
          <div class="portright">
            <div class="form-group">
              <span class="custom-labal ">Shipping Cost :</span>
              <span class="btn bg-success">${{bookingdetails.totalFreightCost}}</span>
            </div>
          </div>
        </div>
        <div class="stripTotal">
          <div class="row">
            <div class="col-md-4 form-group">
              <label class="custom-labal ">
                Total number of units
              </label>
              <span>{{bookingdetails.totalNumberOfUnits}}</span>
            </div>
            <div class="col-md-4 form-group">
              <label class="custom-labal ">
                Total LaneMeters
              </label>
              <span>{{bookingdetails.totalLandMeter}}</span>
            </div>
            <div class="col-md-4 form-group">
              <label class="custom-labal ">
                Total Cubic Meters
              </label>
              <span>{{bookingdetails.totalCubicMeter}}</span>
            </div>
          </div>
        </div>
        <h5 class="modal-title mb-3 mt-3 ">Rate summary</h5>
        <div class="row ui-table">
          <div class="col-md-12 table-responsive   request-summary m-t-30">
            <table class="table table-striped ">
              <tr>
                <th>Description</th>
                <th>Rate Basis</th>
                <th>Rate</th>
                <th>Sum</th>
              </tr>
              <tr>
                <td>
                  Freght Rate
                </td>
                <td>
                  {{selectedRatename}}
                </td>
                <td>
                  {{bookingdetails.freightRate}}
                </td>
                <td>
                  {{bookingdetails.ratetotal}}
                  <!-- <input type="text" class="form-control totalrate" formControlName="ratetotal" readonly /> -->
                </td>
              </tr>
              <tr>
                <td>
                  BAF
                </td>
                <td>
                  {{selectedBAFname}}
                </td>

                <td>
                  {{bookingdetails.baf}}
                </td>
                <td>
                  {{bookingdetails.baftotal}}
                  <!-- <input type="text" class="form-control totalbaf" formControlName="baftotal" readonly /> -->
                </td>
              </tr>
              <tr>
                <td>
                  CAF
                </td>
                <td>
                  {{selectedCafname}}
                </td>
                <td>
                  {{bookingdetails.caf}}
                </td>
                <td>
                  {{bookingdetails.caftotal}}
                </td>
              </tr>
              <tr>
                <td>
                  THC
                </td>
                <td>
                  {{selectedThcname}}
                </td>
                <td>
                  {{bookingdetails.thc}}
                </td>
                <td>
                  {{bookingdetails.thctotal}}
                </td>
              </tr>
              <tr>
                <td>
                  Other Charges
                </td>
                <td>
                  {{selectedOtherchargesname}}
                </td>
                <td>
                  {{bookingdetails.otherCharges}}
                </td>
                <td>
                  {{bookingdetails.otherchargestotal}}
                  <!-- <input type="text" class="form-control totalothercharges" formControlName="otherchargestotal"
                      readonly /> -->
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Total Freight Cost</strong>
                </td>
                <td>

                </td>
                <td>

                </td>
                <td>
                  {{bookingdetails.totalFreightCost}}
                  <!-- <input type="text" class="form-control totalsumofallcost" formControlName="totalsumofallcost"
                      readonly /> -->
                </td>
              </tr>
            </table>
          </div>
        </div>
        <hr class="hr-1 ">
        <h5 class="modal-title  ">Freigh cost summary</h5>

        <div class="stripTotal">
          <div class="row ">
            <div class="col-md-4 form-group">
              <label class="custom-labal ">
                Cost per unit
              </label>
              <label>{{bookingdetails.costPerUnit}}</label>
            </div>
            <div class="col-md-4 form-group">
              <label class="custom-labal ">
                Cost per CubicMeter
              </label>
              <label>{{bookingdetails.costPerCubicMeter}}</label>
            </div>
            <div class="col-md-4 form-group">
              <label class="custom-labal ">
                Total Cost
              </label>
              <label>{{bookingdetails.totalFreightCost}}</label>
            </div>
          </div>
        </div>
        <hr class="hr-1 ">
        <div class="row ">
          <div class="col-md-12">
            <p>
              <span class="text-orange">This rate quotation confirmation contains:</span>
              the tariff ocean rates
              global surcharges such as BAF, SRC and Canal Surcharge where applicable
              validity date for these rates
              standard Terms and Conditions that are applicable
            </p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <strong class="text-orange" style="margin-right: 192px;margin-bottom: 17px;">Please contact customer to fullfill booking
          process</strong>
      </div>
    </div>
  </div>
</div>